// extracted by mini-css-extract-plugin
module.exports = {"avatar":"Avatar_avatar__3O_9l","avatarImg":"Avatar_avatarImg__55dvz"};